import React from 'react'

const tones = {
  single: {
    border: 'border-customAccent/30 dark:border-customAccent/50',
    accent: 'bg-customAccent text-white dark:text-customHeading',
  },
  parlay: {
    border: 'border-customVibrantGreen/30 dark:border-customVibrantGreen/50',
    accent: 'bg-customVibrantGreen text-white dark:text-customHeading',
  },
  default: {
    border: 'border-customMuted/30 dark:border-customSurfaceMuted',
    accent: 'bg-customInk text-white dark:text-customHeading',
  },
}

const EventSelectionCheckbox = ({
  type = 'default',
  checked = false,
  onChange,
  label,
  description= null,
  disabled = false,
  tone,
}) => {
  const toneKey = tone ?? type
  const palette = tones[toneKey] ?? tones.default

  const handleToggle = (event) => {
    if (typeof onChange === 'function') {
      onChange(event.target.checked)
    }
  }

  return (
    <label
      className={[
        'group relative flex cursor-pointer items-center gap-2 rounded-xl border bg-white/80 px-3 py-1 shadow-sm transition',
        'hover:border-customAccent/60 hover:shadow-lg dark:bg-customSurface',
        disabled
          ? 'cursor-not-allowed opacity-60 hover:border-transparent hover:shadow-none'
          : palette.border,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <input
        type="checkbox"
        className="peer absolute inset-0 h-full w-full cursor-pointer opacity-0"
        checked={checked}
        onChange={handleToggle}
        disabled={disabled}
      />
      <span
        className={[
          'flex h-5 w-5 items-center justify-center rounded-lg border border-white/60 text-[10px] font-semibold shadow-sm transition',
          checked
            ? palette.accent
            : 'bg-white text-customSecondaryText dark:bg-customSurfaceMuted dark:text-customMuted',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden="true"
      >
        {checked ? '✓' : ''}
      </span>
      <span className="flex flex-col">
        <span className="text-xs font-semibold uppercase tracking-wide text-customInk dark:text-customHeading">
          {label ?? type}
        </span>
        {description ? (
          <span className="text-[11px] text-customSecondaryText dark:text-customMuted">
            {description}
          </span>
        ) : null}
      </span>
    </label>
  )
}

export default EventSelectionCheckbox

